import React from 'react';
import { CallToAction } from '../../../commonTypes/links';
import { VideoCookiePolicyData } from '../../../commonTypes/video';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { SecondaryCta } from '../../Cta';
import { GridItem } from '../../Grid';
import Video from '../Video';
import {
  Body,
  CtaWrapper,
  GridWithMargins,
  Heading,
  HeadingsWrapper,
  ReverseLayoutMobile,
  Subheading,
} from './styles';

export type FeatureVideoProps = {
  src: string;
  screenReaderText: string;
  heading?: string;
  subheading?: string;
  body?: string;
  forceHeadingsOnTop?: boolean;
  cta?: CallToAction;
  videoCookiePolicyData?: VideoCookiePolicyData;
} & ComponentProps;

const FeatureVideo: React.FC<FeatureVideoProps> = ({
  src,
  screenReaderText,
  heading,
  subheading,
  body,
  forceHeadingsOnTop,
  cta,
  videoCookiePolicyData,
  ...props
}) => {
  const reverseMobileLayout = forceHeadingsOnTop ? false : cta !== undefined;

  return (
    <GridWithMargins {...componentProps(props)}>
      <GridItem desktop={8} tabletLandscape={8} tabletPortrait={6}>
        <ReverseLayoutMobile reverseMobileLayout={reverseMobileLayout}>
          {(heading || subheading) && (
            <HeadingsWrapper tabIndex={0} reverseMobileLayout={reverseMobileLayout}>
              {heading && <Heading>{heading}</Heading>}
              {subheading && <Subheading>{subheading}</Subheading>}
            </HeadingsWrapper>
          )}
          <Video
            src={src}
            screenReaderText={screenReaderText}
            videoCookiePolicyData={videoCookiePolicyData}
          />
        </ReverseLayoutMobile>
        {body && <Body tabIndex={0}>{body}</Body>}
        {cta && (
          <CtaWrapper>
            <SecondaryCta cta={cta} />
          </CtaWrapper>
        )}
      </GridItem>
    </GridWithMargins>
  );
};
export default applyComponentTheme(FeatureVideo, 'FeatureVideo');
